import { useState } from "react"
import { setIsSaved, setSort } from "../../redux/features/filters/filterSlice"
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export default function Filter() {
    
const { sortBy, filterBy} = useSelector(state=> state.filters)
    const dispatch = useDispatch();

    const [filterInput, setFilterInput] = useState({
        all: filterBy ? false:  true,
        isSaved: filterBy
    })
    
    const [sortInput, setSortInput] = useState(sortBy)

    const filtersHandler = (event) => {
        setFilterInput({
            all: !filterInput.all,
            isSaved: !filterInput.isSaved
        })
        if (event.target.value === "all") {
            dispatch(setIsSaved(false))
        }
        if (event.target.value === "isSaved") {
            dispatch(setIsSaved(true))
        }
    }
    const sortHandler = (event) => {
        setSortInput(event.target.value)
        dispatch(setSort(event.target.value))
    }

    return (
        <aside>
            <div className="sidebar-items">
                <div className="sidebar-content">
                    <h4>Sort</h4>
                    <select name="sort" id="lws-sort" className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
                    onChange={sortHandler}
                    value={sortInput}
                    >
                        <option value="">Default</option>
                        <option value="createdAt">Newest</option>
                        <option value="likes">Most Liked</option>
                    </select>
                </div>
                <div className="sidebar-content">
                    <h4>Filter</h4>
                    <div className="radio-group">
                        {/* <!-- handle filter on button click --> */}
                        <div>
                            <input type="radio" name="filter" id="lws-all" className="radio"
                                value="all"
                                checked={filterInput.all}
                                onChange={filtersHandler}
                            />
                            <label htmlFor="lws-all">All</label>
                        </div>
                        <div>
                            <input type="radio" name="filter" id="lws-saved" className="radio"
                                value="isSaved"
                                checked={filterInput.isSaved}
                                onChange={filtersHandler}
                            />
                            <label htmlFor="lws-saved">Saved</label>
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    )
};